if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.productData = null;
        this.currentVariant = null;
        this._syncingToMain = false;
      }

      connectedCallback() {
        this.productJsonEl = this.querySelector('.sticky-atc__product-json');
        this.imageEl = this.querySelector('.sticky-atc__image');
        this.priceEl = this.querySelector('.sticky-atc__price');
        this.comparePriceEl = this.querySelector('.sticky-atc__compare-price');
        this.buttonEl = this.querySelector('.sticky-atc__button');
        this.buttonTextEl = this.querySelector('.sticky-atc__button-text');
        this.qtyInput = this.querySelector('.sticky-atc__qty-input');
        this.optionInputs = [...this.querySelectorAll('.sticky-atc__select')];

        this.mainForm = document.querySelector('product-form form[action*="/cart/add"]');
        if (!this.mainForm) {
          this.mainForm = document.querySelector('form[action*="/cart/add"]');
        }

        if (!this.productJsonEl || !this.buttonEl) return;

        try {
          this.productData = JSON.parse(this.productJsonEl.textContent);
        } catch (error) {
          console.error('Sticky ATC product JSON error:', error);
          return;
        }

        this.currentVariant = this.findInitialVariant();

        this.bindEvents();
        this.watchMainVariantPicker();
        this.updateUI();
        this.initScrollVisibility();
      }

      findInitialVariant() {
        const selectedOptions = this.optionInputs.map((input) => input.value);

        if (selectedOptions.length) {
          const matchedVariant = this.productData.variants.find((variant) => {
            return variant.options.every((optionValue, index) => optionValue === selectedOptions[index]);
          });

          if (matchedVariant) return matchedVariant;
        }

        return this.productData.variants.find((variant) => variant.available) || this.productData.variants[0];
      }

      bindEvents() {
        this.optionInputs.forEach((select) => {
          select.addEventListener('change', () => {
            this.resolveVariantFromOptions();
          });
        });

        this.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
          const value = Math.max(1, parseInt(this.qtyInput.value || '1', 10) - 1);
          this.qtyInput.value = value;
          this.syncMainQuantity();
        });

        this.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
          const value = Math.max(1, parseInt(this.qtyInput.value || '1', 10) + 1);
          this.qtyInput.value = value;
          this.syncMainQuantity();
        });

        this.qtyInput?.addEventListener('input', () => {
          const value = Math.max(1, parseInt(this.qtyInput.value || '1', 10));
          this.qtyInput.value = value;
          this.syncMainQuantity();
        });

        this.buttonEl.addEventListener('click', () => {
          this.handleAddToCart();
        });

        document.addEventListener('click', (e) => {
          const btn = e.target.closest('.variant-card__button[data-variant-id], .variant-card[data-variant-id]');
          if (!btn) return;
          const variantId = parseInt(btn.dataset.variantId, 10);
          if (!variantId) return;
          this.selectVariantById(variantId);
        });
      }

      setActiveCard(variantId) {
        document.querySelectorAll('.variant-card').forEach((card) => {
          card.classList.toggle('active', parseInt(card.dataset.variantId, 10) === variantId);
        });
      }

      selectVariantById(variantId) {
        const variant = this.productData.variants.find((v) => v.id === variantId);
        if (!variant) return;
        this.currentVariant = variant;
        this.optionInputs.forEach((select, i) => {
          if (variant.options[i] !== undefined) select.value = variant.options[i];
        });
        this.setActiveCard(variantId);
        this.updateUI();
        this.updateMainPagePrice();
        this.fetchSectionUpdate(variantId);
        this.syncMainFormOptions();
      }

      updateMainPagePrice() {
        if (!this.currentVariant) return;

        const sectionId = this.dataset.sectionId;
        const priceContainer = sectionId
          ? document.getElementById(`price-${sectionId}`)
          : null;

        if (!priceContainer) return;

        const price = this.currentVariant.price;
        const compareAtPrice = this.currentVariant.compare_at_price;
        const onSale = !!(compareAtPrice && compareAtPrice > price);
        const available = !!this.currentVariant.available;

        priceContainer.classList.toggle('price--on-sale', onSale);
        priceContainer.classList.toggle('price--sold-out', !available);

        if (onSale) {
          const salePriceEl = priceContainer.querySelector('.price__sale .price-item--sale');
          const comparePriceEl = priceContainer.querySelector('.price__sale .price-item--regular');
          if (salePriceEl) salePriceEl.textContent = this.formatMoney(price);
          if (comparePriceEl) comparePriceEl.textContent = this.formatMoney(compareAtPrice);
        } else {
          const regularPriceEl = priceContainer.querySelector('.price__regular .price-item--regular');
          if (regularPriceEl) regularPriceEl.textContent = this.formatMoney(price);
        }
      }

      fetchSectionUpdate(variantId) {
        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        fetch(`${window.location.pathname}?section_id=${sectionId}&variant=${variantId}`)
          .then((r) => (r.ok ? r.text() : Promise.reject()))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');

            // Replace price container (handles sale/regular/sold-out states)
            const freshPrice = doc.getElementById(`price-${sectionId}`);
            const livePrice = document.getElementById(`price-${sectionId}`);
            if (freshPrice && livePrice) {
              livePrice.innerHTML = freshPrice.innerHTML;
              livePrice.className = freshPrice.className;
            }

            // Update featured media image — update src/srcset only to avoid
            // breaking the gallery slider's JS state
            const freshGallery = doc.getElementById(`MediaGallery-${sectionId}`);
            const liveGallery = document.getElementById(`MediaGallery-${sectionId}`);
            if (freshGallery && liveGallery) {
              const freshImg = freshGallery.querySelector('img[srcset]');
              const liveImg = liveGallery.querySelector('img[srcset]');
              if (freshImg && liveImg) {
                liveImg.src = freshImg.src;
                liveImg.srcset = freshImg.srcset;
              }
            }
          })
          .catch(() => {});
      }

      initScrollVisibility() {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const mobileShowThreshold = 0.06;
  const desktopElementThreshold = 0.06;
  const nearFooterThreshold = 0.9;
  const directionTolerance = 6;

  let lastScrollTop = Math.max(
    window.scrollY || window.pageYOffset || 0,
    0
  );

  let ticking = false;

  const updateVisibility = () => {
    const scrollTop = Math.max(
      window.scrollY || window.pageYOffset || 0,
      0
    );

    const documentHeight =
      Math.max(
        document.documentElement.scrollHeight,
        document.body ? document.body.scrollHeight : 0
      ) - window.innerHeight;

    if (documentHeight <= 0) {
      this.classList.remove('is-visible');
      this.classList.remove('is-near-footer');
      document.body.classList.remove('sticky-atc-visible');

      lastScrollTop = scrollTop;
      ticking = false;
      return;
    }

    const progress = Math.min(
      Math.max(scrollTop / documentHeight, 0),
      1
    );

    const hasReachedMobileThreshold =
      progress >= mobileShowThreshold;

    const isNearFooter =
      progress >= nearFooterThreshold;

    const scrollDelta =
      scrollTop - lastScrollTop;

    const isScrollingDown =
      scrollDelta > directionTolerance;

    const isScrollingUp =
      scrollDelta < -directionTolerance;

    let shouldShow;
    let bodyShouldShow;

    if (!mobileQuery.matches) {
      /*
        Preserve the original non-mobile behavior exactly.
        The sticky element receives is-visible from 17%.
        The body helper class is active from 17% to 80%.
      */
      shouldShow =
        progress >= desktopElementThreshold;

      bodyShouldShow =
        progress >= mobileShowThreshold &&
        !isNearFooter;
    } else if (
      !hasReachedMobileThreshold ||
      isNearFooter
    ) {
      /*
        On mobile, keep the sticky ATC hidden before
        17% scroll depth and close to the footer.
      */
      shouldShow = false;
      bodyShouldShow = false;
    } else if (isScrollingDown) {
      /*
        Beyond 17%, show it when scrolling down.
      */
      shouldShow = true;
      bodyShouldShow = true;
    } else if (isScrollingUp) {
      /*
        Beyond 17%, hide it when scrolling up.
      */
      shouldShow = false;
      bodyShouldShow = false;
    } else {
      /*
        Ignore very small finger movements so the
        bar does not flicker on mobile devices.
      */
      shouldShow =
        this.classList.contains('is-visible') &&
        !this.classList.contains('is-near-footer');

      bodyShouldShow = shouldShow;
    }

    this.classList.toggle(
      'is-visible',
      shouldShow
    );

    this.classList.toggle(
      'is-near-footer',
      isNearFooter
    );

    document.body.classList.toggle(
      'sticky-atc-visible',
      bodyShouldShow
    );

    if (
      Math.abs(scrollDelta) >
      directionTolerance
    ) {
      lastScrollTop = scrollTop;
    }

    ticking = false;
  };

  const requestVisibilityUpdate = () => {
    if (ticking) return;

    ticking = true;

    window.requestAnimationFrame(
      updateVisibility
    );
  };

  updateVisibility();

  window.addEventListener(
    'scroll',
    requestVisibilityUpdate,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    requestVisibilityUpdate
  );
}

      resolveVariantFromOptions() {
        const selectedOptions = this.optionInputs.map((input) => input.value);

        const matchedVariant = this.productData.variants.find((variant) => {
          return variant.options.every((optionValue, index) => optionValue === selectedOptions[index]);
        });

        if (!matchedVariant) return;

        this.currentVariant = matchedVariant;
        this.setActiveCard(matchedVariant.id);
        this.updateUI();
        this.syncMainFormOptions();
      }

      watchMainVariantPicker() {
        // Dropdown selects inside variant-selects
        document.querySelectorAll('variant-selects select[name^="options["]').forEach((select) => {
          select.addEventListener('change', () => this.syncFromMainPicker());
        });
        // Pill / radio buttons inside variant-selects (button picker type)
        document.querySelectorAll('variant-selects input[type="radio"]').forEach((radio) => {
          radio.addEventListener('change', () => this.syncFromMainPicker());
        });
        // Pill / radio buttons inside variant-radios (fallback for other themes)
        document.querySelectorAll('variant-radios input[type="radio"]').forEach((radio) => {
          radio.addEventListener('change', () => this.syncFromMainPicker());
        });
      }

      syncFromMainPicker() {
        if (this._syncingToMain) return;

        const selectedOptions = [];

        // Try dropdown selects first
        const mainSelects = document.querySelectorAll('variant-selects select[name^="options["]');
        if (mainSelects.length) {
          mainSelects.forEach((select) => selectedOptions.push(select.value));
        }

        // Try pill buttons inside variant-selects (button picker type)
        if (!selectedOptions.length) {
          document.querySelectorAll('variant-selects fieldset').forEach((fieldset) => {
            const checked = fieldset.querySelector('input[type="radio"]:checked');
            if (checked) selectedOptions.push(checked.value);
          });
        }

        // Try variant-radios as final fallback
        if (!selectedOptions.length) {
          document.querySelectorAll('variant-radios fieldset').forEach((fieldset) => {
            const checked = fieldset.querySelector('input[type="radio"]:checked');
            if (checked) selectedOptions.push(checked.value);
          });
        }

        if (!selectedOptions.length) return;

        const matchedVariant = this.productData.variants.find((variant) =>
          variant.options.every((val, i) => val === selectedOptions[i])
        );

        if (!matchedVariant || matchedVariant.id === this.currentVariant?.id) return;

        this.currentVariant = matchedVariant;
        this.optionInputs.forEach((select, i) => {
          if (selectedOptions[i] !== undefined) select.value = selectedOptions[i];
        });
        this.updateUI();
      }

      formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, window.Shopify.money_format);
        }

        return `${(cents / 100).toFixed(2)}`;
      }

      updateUI() {
        if (!this.currentVariant) return;

        if (this.priceEl) {
          this.priceEl.textContent = this.formatMoney(this.currentVariant.price);
        }

        if (this.comparePriceEl) {
          if (this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price) {
            this.comparePriceEl.textContent = this.formatMoney(this.currentVariant.compare_at_price);
            this.comparePriceEl.style.display = '';
          } else {
            this.comparePriceEl.style.display = 'none';
          }
        }

        const featuredImage =
          this.currentVariant.featured_media?.preview_image?.src ||
          this.currentVariant.featured_image?.src ||
          this.currentVariant.featured_media?.src;

        if (this.imageEl && featuredImage) {
          this.imageEl.src = featuredImage;
        }

        const available = !!this.currentVariant.available;
        this.buttonEl.disabled = !available;
        this.buttonTextEl.textContent = available ? 'In winkelwagen' : 'Uitverkocht';
      }

      syncMainQuantity() {
        if (!this.mainForm) return;

        const mainQtyInput = this.mainForm.querySelector('input[name="quantity"]');
        if (mainQtyInput) {
          mainQtyInput.value = Math.max(1, parseInt(this.qtyInput.value || '1', 10));
          mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }

      syncMainFormOptions() {
        if (!this.mainForm) return;

        this._syncingToMain = true;
        const stickyValues = this.optionInputs.map((input) => input.value);

        // 1. Dropdown selects (picker_type: dropdown)
        // Use document scope — selects may be outside <form> via the form= attribute
        const mainSelects = document.querySelectorAll('variant-selects select[name^="options["]');
        mainSelects.forEach((select, index) => {
          if (stickyValues[index] === undefined) return;
          select.value = stickyValues[index];
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });

        // 2. Pill / radio buttons — indexed by fieldset position to avoid value collisions
        ['variant-selects', 'variant-radios'].forEach((wrapper) => {
          document.querySelectorAll(`${wrapper} fieldset`).forEach((fieldset, optionIndex) => {
            const value = stickyValues[optionIndex];
            if (value === undefined) return;
            const radio = fieldset.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });

        const hiddenVariantInput = this.mainForm.querySelector('input[name="id"]');
        if (hiddenVariantInput && this.currentVariant) {
          hiddenVariantInput.value = this.currentVariant.id;
          hiddenVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        this.syncMainQuantity();
        this._syncingToMain = false;
      }

      handleAddToCart() {
        if (!this.currentVariant || !this.currentVariant.available) return;

        this.buttonEl.classList.add('loading');
        this.buttonEl.setAttribute('aria-disabled', 'true');

        // Set variant ID and quantity directly — no change events to avoid
        // triggering Dawn's scroll/focus behaviour on variant change.
        // Shopify's /cart/add only needs id + quantity; options[] are ignored.
        const currentForm =
          document.querySelector('product-form form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add"]');

        if (!currentForm) {
          console.error('Sticky ATC: main product form not found.');
          this.buttonEl.classList.remove('loading');
          this.buttonEl.removeAttribute('aria-disabled');
          return;
        }

        const hiddenVariantInput = currentForm.querySelector('input[name="id"]');
        if (hiddenVariantInput) hiddenVariantInput.value = this.currentVariant.id;

        this.syncMainQuantity();

        setTimeout(() => {
          const submitButton =
            currentForm.querySelector('button[name="add"]') ||
            currentForm.querySelector('[type="submit"]');

          if (!submitButton) {
            console.error('Sticky ATC: submit button not found.');
            this.buttonEl.classList.remove('loading');
            this.buttonEl.removeAttribute('aria-disabled');
            return;
          }

          submitButton.click();

          setTimeout(() => {
            this.buttonEl.classList.remove('loading');
            this.buttonEl.removeAttribute('aria-disabled');
          }, 800);
        }, 120);
      }
    }
  );
}

